import React from 'react';
import { Message } from '@/types/message-types';

interface ReactionChipsProps {
  reactions: Array<{
    emoji: string;
    count: number;
    senderIds: string[];
  }>;
  isOutgoing: boolean;
}

export const ReactionChips = React.memo(function ReactionChips({
  reactions,
  isOutgoing
}: ReactionChipsProps) {
  if (reactions.length === 0) {
    return null;
  }

  return (
    <div className={`
      flex flex-wrap gap-1 mt-1
      ${isOutgoing ? 'justify-end' : 'justify-start'}
    `}>
      {reactions.map((reaction, index) => (
        <div
          key={`${reaction.emoji}-${index}`}
          className={`
            inline-flex items-center gap-1 
            px-2 py-1 rounded-full text-xs
            bg-secondary/70 border border-secondary
            hover:bg-secondary/90 transition-colors cursor-default
            select-none
          `}
        >
          <span className="text-sm leading-none">{reaction.emoji}</span>
          {reaction.count > 1 && (
            <span className="text-xs text-muted-foreground font-medium">
              {reaction.count}
            </span>
          )}
        </div>
      ))}
    </div>
  );
});